import { PropsWithClassName } from '@/types';

export function AdSlot({
  className = '',
  divId,
  variant,
}: PropsWithClassName<{ divId: string; variant?: 'HORIZONTAL' | 'BOX' }>) {
  const variantClass =
    variant === 'HORIZONTAL'
      ? 'w-full flex mx-auto justify-center'
      : 'h-[250px] w-[300px]';

  return <div className={`${className} ${variantClass}`} id={divId} />;
}
